import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, Button, EqualHeight, ModalTrigger, Separator } from 'telia-front-react';
import { PackageIds } from '../stores/MobileLifeStore';
import { useStores } from '../stores/RootStore';
import { normalizeId } from '../util/TextUtil';

export interface PrivateMobileCardButtonsProps {
  packageName: string;
  packageIds: PackageIds;
  forSingleUserOnly: boolean;
  singleUserUrl: string;
  hideViewDetailsButton?: boolean;
  inModal?: boolean;
}

const PrivateMobileCardButtons = observer((props: PrivateMobileCardButtonsProps): React.JSX.Element => {
  const {
    mobileLifeStore: { selectedDeviceCount, getPackageId, setOrderModalOpen, setSelectedMobilePackage },
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);
  const { packageName, packageIds, forSingleUserOnly, singleUserUrl, hideViewDetailsButton, inModal } = props;
  const packageId = getPackageId(packageIds);

  const openMultipleUserOrderModal = () => {
    setOrderModalOpen(true);
    setSelectedMobilePackage(packageId);
  };

  const renderOrderButton = (url?: string, onClick?: () => void): JSX.Element => (
    <Button
      text={translate('mobile.package.order')}
      url={url}
      block={true}
      onClick={onClick}
      iconRight="#arrow-right"
      type="expressive"
      aria-describedby={`${inModal ? 'modal-' : ''}mobile-package-title-${normalizeId(packageName)}`}
    />
  );

  return (
    <EqualHeight group="cta">
      {!hideViewDetailsButton && (
        <AnalyticsTrigger
          trigger={{
            callback: 'onClick',
            id: `Link - ${packageName} - Vaatan lähemalt`,
          }}
        >
          <ModalTrigger>
            <Button
              text={translate('mobile.package.viewDetails')}
              variant="secondary"
              block={true}
              aria-describedby={`mobile-package-title-${normalizeId(packageName)}`}
            />
          </ModalTrigger>
        </AnalyticsTrigger>
      )}
      <Separator color="invisible" spacing="xsmall" />
      {!forSingleUserOnly && selectedDeviceCount > 1 ? (
        <AnalyticsTrigger trigger={{ callback: 'onClick', id: 'CTA - Form - Mobiilne Elu' }}>
          {renderOrderButton(null, openMultipleUserOrderModal)}
        </AnalyticsTrigger>
      ) : (
        <AnalyticsTrigger
          trigger={{
            callback: 'onClick',
            id: `CTA - ${packageName} mobiilipakett`,
          }}
        >
          {renderOrderButton(singleUserUrl)}
        </AnalyticsTrigger>
      )}
    </EqualHeight>
  );
});

export default PrivateMobileCardButtons;
